import Home from '@/views/frontend/Home'
import Dashboard from '@/views/frontend/dashboard/Dashboard'
import PendingPage from '@/views/frontend/dashboard/PendignPage'
import ESignPage from '@/views/frontend/dashboard/ESignPage'
import HistoryPage from '@/views/frontend/dashboard/HistoryPage'
import CompleteView from '@/views/frontend/dashboard/CompleteView'

var prefix = '/customer';
export default [
    {
        path:   prefix+'/home',
        name : 'customerHome',
        component:Home,
    },
    {
        path:   prefix+'/dashboard/:client_number/:document_id',
        name : 'customerDashboard',
        component:Dashboard,
    },
    {
        path:   prefix+'/dashboard/pending',
        name : 'customerDashboardPending',
        component:PendingPage,
    },
    {
        path:   prefix+'/dashboard/esign',
        name : 'customerDashboardEsign',
        component:ESignPage,
    },
    {
        path:   prefix+'/dashboard/history',
        name : 'customerDashboardHistory',
        component:HistoryPage,
    },
    {
        path:   prefix+'/home/clientToken',
        name : 'customerSignInHome',
        component:Home,
    },



    {
        path:   prefix+'/complete',
        name : 'completeView',
        component:CompleteView,
    },


]
